import React from 'react';
import { Container, Button, Navbar, Nav } from 'react-bootstrap';

// Shared chrome for the public blog: a sticky top nav matching the landing
// page and a footer linking back to the app and legal pages. Links are real
// <a href> anchors (not router navigation) so they remain crawlable and work
// for logged-out visitors, who hit the public routes handled in App.js.
function BlogLayout({ children }) {
  return (
    <div className="legal-page d-flex flex-column">
      <Navbar className="landing-nav" sticky="top" expand={false}>
        <Container>
          <a href="/home" className="navbar-brand d-flex align-items-center gap-2">
            <img
              src="/apple-icon-180x180.png"
              alt="Plum"
              style={{ width: 32, height: 32, borderRadius: 8 }}
            />
            <span style={{ color: 'var(--text-primary)', fontWeight: 600 }}>Plum</span>
          </a>
          <Nav>
            <Button variant="outline-dark" className="landing-nav-btn" href="/home" size="sm">
              Get Started Free
            </Button>
          </Nav>
        </Container>
      </Navbar>

      <div className="flex-grow-1">{children}</div>

      <footer className="landing-footer text-center">
        <Container>
          <p className="mb-2">&copy; 2026 Plum. AI-powered renovation planning.</p>
          <p className="mb-0">
            <a href="/blog" className="landing-footer-link">Blog</a>
            <span className="mx-2">|</span>
            <a href="/terms" className="landing-footer-link">Terms of Service</a>
            <span className="mx-2">|</span>
            <a href="/privacy" className="landing-footer-link">Privacy Policy</a>
          </p>
        </Container>
      </footer>
    </div>
  );
}

export default BlogLayout;
